import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchExamReport, fetchSectionExamReports } from "../../../redux/examSlice";
import { fetchCampusDetails } from "../../../redux/campusesSlice";
import { fetchTeacherReport } from "../../../redux/teacherReportSlice";
import ViewReportModal from "./ViewReportModal";
import ListOfTeacherReport from "./ListOfTeacherReport";
import toast from "react-hot-toast";

const ListOfTeacher = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [viewReportOpen, setViewReportOpen] = useState(false);
  const [teacherReportOpen, setTeacherReportOpen] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [selectedCampusId, setSelectedCampusId] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [viewSectionReport, setViewSectionReport] = useState(false);
  
  const { campusDetails, loading } = useSelector((state) => state.campuses);
  
  const selectedCampus = campusDetails.find(campus => campus.id === selectedCampusId) || { classes: [] };
  const availableClasses = selectedCampus.classes || [];
  
  const selectedClass = availableClasses.find(cls => cls.id === selectedClassId) || { sections: [] };
  const availableSections = selectedClass.sections || [];
  
  const selectedSection = availableSections.find(section => section.id === selectedSectionId) || { students: [] };

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchCampusDetails());
    }
  }, [isOpen, dispatch]);
  
  useEffect(() => {
    if (selectedCampusId === "") {
      setSelectedClassId("");
      setSelectedSectionId("");
      setSelectedStudentId("");
    }
  }, [selectedCampusId]);
  
  useEffect(() => {
    if (selectedClassId === "") {
      setSelectedSectionId("");
      setSelectedStudentId("");
    }
  }, [selectedClassId]);
  
  useEffect(() => {
    if (selectedSectionId === "") {
      setSelectedStudentId("");
    }
  }, [selectedSectionId]);

  const handleViewReport = () => {
    if (selectedStudentId) {
      dispatch(fetchExamReport(selectedStudentId));
      setViewSectionReport(false);
      setViewReportOpen(true);
    }
  };

  const handleViewSectionReport = () => {
    if (selectedSectionId) {
      dispatch(fetchSectionExamReports({ id: selectedSectionId }));
      setViewSectionReport(true);
      setViewReportOpen(true);
    } else {
      toast.error("Please select a section first");
    }
  };

  const handleViewTeacherReport = () => {
    if (selectedSectionId) {
      dispatch(fetchTeacherReport({
        campusId: selectedCampusId,
        classId: selectedClassId,
        sectionId: selectedSectionId
      }));
      setTeacherReportOpen(true);
    } else {
      toast.error("Please select a section first");
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-[60%] relative">
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <label htmlFor="campus" className="block mb-2">
                Campus
              </label>
              <select 
                id="campus" 
                className="border p-2 rounded w-full"
                value={selectedCampusId}
                onChange={(e) => setSelectedCampusId(e.target.value)}
                disabled={loading}
              >
                <option value="" disabled>
                  Choose a campus
                </option>
                {campusDetails.map((campus) => (
                  <option key={campus.id} value={campus.id}>
                    {campus.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="grade" className="block mb-2">
                Grade
              </label>
              <select 
                id="grade" 
                className="border p-2 rounded w-full"
                value={selectedClassId}
                onChange={(e) => setSelectedClassId(e.target.value)}
                disabled={!selectedCampusId || loading}
              >
                <option value="" disabled>
                  Choose a grade
                </option>
                {availableClasses.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.className}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <label htmlFor="section" className="block mb-2">
                Section
              </label>
              <select 
                id="section" 
                className="border p-2 rounded w-full"
                value={selectedSectionId}
                onChange={(e) => setSelectedSectionId(e.target.value)}
                disabled={!selectedClassId || loading}
              >
                <option value="" disabled>
                  Choose a section
                </option>
                {availableSections.map((section) => (
                  <option key={section.id} value={section.id}>
                    {section.sectionName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              onClick={onClose}
              className="bg-gray-400 px-4 py-2 rounded text-white"
            >
              Close
            </button>
            <button
              onClick={handleViewTeacherReport}
              className="bg-[#241763] px-4 py-2 rounded text-white"
              disabled={!selectedSectionId || loading}
            >
              View Teacher List Report
            </button>
          </div>
        </div>
      </div>

      <ViewReportModal
        isOpen={viewReportOpen}
        onClose={() => setViewReportOpen(false)}
        studentId={selectedStudentId}
        sectionId={selectedSectionId}
        isSectionReport={viewSectionReport}
        sectionName={selectedSection.sectionName}
        className={selectedClass.className}
        campusName={selectedCampus.name} 
      />

      <ListOfTeacherReport
        isOpen={teacherReportOpen}
        onClose={() => setTeacherReportOpen(false)}
        selectedCampusId={selectedCampusId}
        selectedClassId={selectedClassId}
        selectedSectionId={selectedSectionId}
        campusName={selectedCampus.name}
        className={selectedClass.className}
        sectionName={selectedSection.sectionName}
      />
    </>
  );
};

export default ListOfTeacher;